import { QuoteStatus } from '@40seas/entities/currency-exchange';
import { EnumColor } from '@40seas/frontend/common/providers';

export const QuoteStatusMapping = {
    [QuoteStatus.Active]: 'success',
    [QuoteStatus.Expired]: 'secondary',
} as { [key in QuoteStatus]: EnumColor };
